import { itemsShowmore } from "javascripts/webpage/items-showmore";

document.addEventListener("DOMContentLoaded", () => {
  if (!document.querySelectorAll("#js-prefectures")) {
    return;
  }
  itemsShowmore();
});
